import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Layout } from '@/components/layout/Layout';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { Home } from '@/pages/Home';
import { Browse } from '@/pages/Browse';
import { SearchPage } from '@/pages/Search';
import { QuoteDetail } from '@/pages/QuoteDetail';
import { Categories } from '@/pages/Categories';
import { CategoryPage } from '@/pages/CategoryPage';
import { Authors } from '@/pages/Authors';
import { AuthorPage } from '@/pages/AuthorPage';
import { Favorites } from '@/pages/Favorites';
import { Login } from '@/pages/Login';
import { NotFound } from '@/pages/NotFound';
import { DashboardPage } from '@/pages/admin/Dashboard';
import { QuoteManagerPage } from '@/pages/admin/QuoteManager';
import { QuoteEditorPage } from '@/pages/admin/QuoteEditor';
import { SettingsPage } from '@/pages/admin/Settings';
import { TelegramSettingsPage } from '@/pages/admin/TelegramSettings';
import { SchedulerSettingsPage } from '@/pages/admin/SchedulerSettings';
import { useTheme } from '@/hooks/useTheme';

function App() {
  useTheme();

  return (
    <div className="min-h-screen">
      <Layout>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/quote/:id" element={<QuoteDetail />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/authors" element={<Authors />} />
            <Route path="/author/:slug" element={<AuthorPage />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout><DashboardPage /></AdminLayout>} />
            <Route path="/admin/quotes" element={<AdminLayout><QuoteManagerPage /></AdminLayout>} />
            <Route path="/admin/quotes/new" element={<AdminLayout><QuoteEditorPage /></AdminLayout>} />
            <Route path="/admin/quotes/edit/:id" element={<AdminLayout><QuoteEditorPage /></AdminLayout>} />
            <Route path="/admin/settings" element={<AdminLayout><SettingsPage /></AdminLayout>} />
            <Route path="/admin/telegram" element={<AdminLayout><TelegramSettingsPage /></AdminLayout>} />
            <Route path="/admin/scheduler" element={<AdminLayout><SchedulerSettingsPage /></AdminLayout>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </Layout>
    </div>
  );
}

export default App;
